<template>
  <div ref="refcontrolcontainer" class="pb-4">
    <v-text-field
      :id="`form-image-ext-editor-${tag.name}`"
      :value="storageFix"
      :label="tag.description"
      outlined
      readonly
      dense
      clearable
      class="fm-text-field"
      hide-details
      @click="fmOpen"
      @click:clear="fmReset"
    >
      <template v-slot:append>
        <div class="d-flex">
          <v-icon @click="fmOpen">mdi-image-search-outline</v-icon>
          <uploader-button
            :work-dir="workDir"
            class="d-block"
            @upload-success="onImageUpload"
            @upload-error="onUploadError"
          >
            <v-icon>mdi-upload</v-icon>
          </uploader-button>
        </div>
      </template>
    </v-text-field>
    <image-mini v-if="hasImage" v-model="imageAssets" :src="fullImagePath" />
    <file-manager-dialog
      v-model="fmDialog"
      src="imageeditor"
      :selected-path="storageFix"
      :work-dir="workDir"
      :allowed-extensions="['jpg', 'jpeg', 'png', 'svg', 'gif']"
      @fm-select="fmSelect"
      @fm-close="fmClose"
    />
  </div>
</template>

<script>
import ImageMini from "@/components/ImageMini.vue";
import FileManagerDialog from "./FileManagerDialog/FileManagerDialog.vue";
import UploaderButton from "@/components/UploaderButton.vue";

export default {
  components: {
    FileManagerDialog,
    ImageMini,
    UploaderButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fmDialog: false
    };
  },
  computed: {
    imageAssets: {
      get() {
        const src = this.value ? this.value.i_main || "" : "";
        const left = this.value ? this.value.i_left || null : null;
        const top = this.value ? this.value.i_top || null : null;
        const right = this.value ? this.value.i_right || null : null;
        const bottom = this.value ? this.value.i_bottom || null : null;
        return { src, left, top, right, bottom };
      },
      set(val) {
        const data = {
          i_main: val.src,
          i_left: val.left,
          i_top: val.top,
          i_right: val.right,
          i_bottom: val.bottom
        };
        this.$emit("input", data);
      }
    },
    workDir() {
      return this.tag?.custom_settings?.images_dir || "/images";
    },
    storageFix() {
      return (this.value?.i_main || "").replace("<STORAGE>", "");
    },
    hasImage() {
      return (this.value?.i_main || "").length > 0;
    },
    fullImagePath() {
      return (this.value?.i_main || "").replace(
        "<STORAGE>",
        this.$store.getters.getStoragePrefix
      );
    }
  },

  methods: {
    fmOpen() {
      this.fmDialog = true;
    },
    fmClose() {
      this.fmDialog = false;
    },
    fmReset() {
      this.$emit("input", {});
    },
    fmSelect(file) {
      this.fmDialog = false;
      let newValue = file;
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.imageAssets.i_main = `<STORAGE>${newValue}`;
      this.$emit("input", this.imageAssets);
    },
    onImageUpload(files) {
      let newValue = files[0];
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.imageAssets.i_main = `<STORAGE>${newValue}`;
      this.$emit("input", this.imageAssets);
    },
    onUploadError(error) {
      this.$store.commit("addNotice", {
        type: "error",
        message: error
      });
    }
  }
};
</script>
